// @flow

import _ from 'lodash';
import type { FilterDataState, FilterDataAction } from 'stores/flow-type/filter-data.type';

import {
  GET_FILTER_DATA_REQUEST,
  GET_FILTER_DATA_SUCCESS,
  GET_FILTER_DATA_FAILURE,
  GET_PRODUCT_ATTRIBUTE_REQUEST,
  GET_PRODUCT_ATTRIBUTE_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_FAILURE,
  GET_FILTER_DATA_BY_TYPE_REQUEST,
  GET_FILTER_DATA_BY_TYPE_SUCCESS,
  GET_FILTER_DATA_BY_TYPE_FAILURE
} from 'stores/flow-type/filter-data.type';

const initialState: FilterDataState = {
  loading: false,
  success: false,
  loadingDataByType: false,
  successDataByType: false,
  error: undefined,
  filterData: {},
  productAttributes: {},
  filterDataByType: [],
  filterDataOptions: {
    tags: [],
    product_types: [],
    product_categories: [],
    vendors: []
  },
  filterDataType: '',
  filterDataByTypeFirstPage: []
};

const parseFilterData = data => {
  let {
    collections,
    tags,
    vendors,
    product_types,
    product_categories,
    options,
    customRangeSliders,
    locations = [],
    metaobjects = {}
  } = data;
  let filterData = {};
  let optionsListData = [];

  if (!_.isEmpty(collections)) {
    collections = _.map(collections, item => ({
      value: item.id.toString(),
      label: item.title,
      handle: item.handle,
      sort_order: item.sort_order
    }));
  }
  if (!_.isEmpty(tags)) {
    tags = _.map(tags, item => ({ value: item, label: item }));
  }
  if (!_.isEmpty(vendors)) {
    vendors = _.map(vendors, item => ({ value: item, label: item }));
  }
  if (!_.isEmpty(product_types)) {
    product_types = _.map(product_types, item => ({ value: item, label: item }));
  }
  if (!_.isEmpty(product_categories)) {
    product_categories = _.map(product_categories, item => ({ value: item, label: item }));
  }

  const optionsList = [];
  if (!_.isEmpty(options)) {
    optionsListData = _.map(options, item => {
      filterData[item.name] = _.map(item.values, item1 => ({ value: item1, label: item1 }));
      optionsList.push({ name: item.name, originalName: item.originalName });
      return { value: item.name, label: item.originalName };
    });
  }

  let metafieldList = [];
  Object.keys(data).forEach(type => {
    if (_.startsWith(type, 'metafield')) {
      filterData[type] = _.map(data[type], item => ({ value: item, label: item }));
      metafieldList.push(type);
    }
  });

  // Location inventory
  if (_.isArray(locations)) {
    locations = _.map(locations, location => ({
      value: location.name,
      label: location.name,
      fulfillsOnlineOrders: location.fulfillsOnlineOrders
    }));
  }

  return {
    ...filterData,
    collections,
    tags,
    vendors,
    productTypes: product_types,
    productCategories: product_categories,
    optionsList,
    optionsListData,
    metafieldList,
    customRangeSliders,
    locations,
    metaobjects
  }
}

const filterDataReducers = (state: FilterDataState = initialState, action: FilterDataAction) => {
  switch (action.type) {
    case GET_FILTER_DATA_REQUEST:
      return { ...state, loading: true };
    case GET_FILTER_DATA_SUCCESS: {
      let { data } = action.payload;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        filterData: parseFilterData(data)
      };
    }
    case GET_FILTER_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case GET_PRODUCT_ATTRIBUTE_REQUEST:
      return { ...state, loading: true };
    case GET_PRODUCT_ATTRIBUTE_SUCCESS: {
      let { data } = action.payload;

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        productAttributes: parseFilterData(data)
      };
    }
    case GET_PRODUCT_ATTRIBUTE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    case GET_FILTER_DATA_BY_TYPE_REQUEST:
      return { ...state, loadingDataByType: true, successDataByType: false };
    case GET_FILTER_DATA_BY_TYPE_SUCCESS: {
      let { data, type, skip, prefix } = action.payload;

      let filterDataByType = _.get(data, 'data', []);

      let filterDataOptions = {
        ...state.filterDataOptions
      };
      // Support vendor, product types, tags, product_categories
      if (
        [
          'vendors',
          'product_types',
          'tags',
          'options',
          'product_categories',
          'metafields'
        ].includes(type)
      ) {
        filterDataByType = _.map(filterDataByType, item => ({ value: item, label: item }));
      }

      if (type === 'collections') {
        filterDataByType = _.map(filterDataByType, item => ({
          value: item.id.toString(),
          label: item.title,
          handle: item.handle,
          sort_order: item.sort_order
        }));
      }

      if (type === 'options') {
        filterDataOptions[prefix] = filterDataByType;
      } else {
        filterDataOptions[type] = filterDataByType;
      }
      // (Only render preview) Skip === 0 => Save data of first page
      const filterDataByTypeFirstPage = skip ? state.filterDataByTypeFirstPage : filterDataByType;

      return {
        ...state,
        loadingDataByType: false,
        successDataByType: true,
        error: undefined,
        filterDataOptions,
        filterDataByType,
        filterDataType: type,
        filterDataByTypeFirstPage
      };
    }
    case GET_FILTER_DATA_BY_TYPE_FAILURE:
      return {
        ...state,
        loadingDataByType: false,
        successDataByType: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default filterDataReducers;
